// @ts-expect-error static asset
import cmsFreeImageUrl from 'bender-url!../../img/cms-free-signup.png';
// @ts-expect-error static asset
import cmsFreeImageUrl2x from 'bender-url!../../img/cms-free-signup-2x.png';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Image } from 'foundations-components/transitional/components/Image';
import { getIsPrerenderUserAgent } from 'marketplace-ui-common/utils/userAgent';
import { Fragment } from 'react';
import { isQa } from '../utils/env';
import { getAssetInAppShortUrl, getCmsFreeSignUpUrl } from '../utils/urls';
import MediaSection from './MediaSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function CmsFreeSection({
  onTrackInteraction
}) {
  const isPrerender = getIsPrerenderUserAgent();
  return /*#__PURE__*/_jsx(MediaSection, {
    button: !isPrerender && /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx(Button, {
        "data-test-id": "cms-signup-button",
        href: getCmsFreeSignUpUrl({
          query: {
            intent: 'marketplaceTheme'
          },
          env: isQa() ? 'qa' : 'prod'
        }),
        onClick: () => onTrackInteraction('click cms free signup button'),
        use: "tertiary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceUnified.sections.cmsFree.signUpButtonText"
        })
      }), /*#__PURE__*/_jsx(Button, {
        "data-test-id": "cms-login-button",
        href: getAssetInAppShortUrl(),
        onClick: () => onTrackInteraction('click cms free login button'),
        use: "tertiary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplaceUnified.sections.cmsFree.loginButtonText"
        })
      })]
    }),
    color: "fill-surface-raised",
    "data-test-id": "cms-free-section",
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplaceUnified.sections.cmsFree.description"
    }),
    media: /*#__PURE__*/_jsx(Image, {
      src: cmsFreeImageUrl,
      srcSet: `${cmsFreeImageUrl2x} 2x`,
      inlineSize: "100%",
      maxInlineSize: "500px"
    }),
    orientation: "media-right",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplaceUnified.sections.cmsFree.title"
    })
  });
}